import React from "react";

// ===============================
// CONSTANTS
// ===============================
const EXCAVATION_STAT_CARDS = [
  {
    key: "total",
    label: "Total Points",
    valueKey: "total",
    bgColor: "bg-primary/10",
    textColor: "text-primary-dark",
  },
  {
    key: "active",
    label: "Active",
    valueKey: "active",
    bgColor: "bg-green-50",
    textColor: "text-green-700",
  },
  {
    key: "planned",
    label: "Planned",
    valueKey: "planned",
    bgColor: "bg-yellow-50",
    textColor: "text-yellow-700",
  },
  {
    key: "completed",
    label: "Completed",
    valueKey: "completed",
    bgColor: "bg-gray-50",
    textColor: "text-gray-700",
  },
  {
    key: "suspended",
    label: "Suspended",
    valueKey: "suspended",
    bgColor: "bg-red-50",
    textColor: "text-red-700",
  },
];

// ===============================
// COMPONENT
// ===============================
const StatisticsCards = ({ statusCounts }) => {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-5 gap-2 lg:gap-3">
      {EXCAVATION_STAT_CARDS.map(
        ({ key, label, valueKey, bgColor, textColor }) => (
          <div key={key} className={`${bgColor} rounded-lg p-3 text-center`}>
            <div className={`text-lg font-bold ${textColor}`}>
              {statusCounts[valueKey] || 0}
            </div>
            <div className="text-xs text-gray-600">{label}</div>
          </div>
        )
      )}
    </div>
  );
};

export default StatisticsCards;
